function Location_form_country_edit(element) {
    this.$element = $(element);

    this.selectors = {
		formParent: 'form[data-i4-decorator="Validator_form"]',
		filterDecoratorCountry: '.js-filter-decorator-country'
    };

    this.triggers = {
	    beforeSubmit: 'i4:beforeSubmit',
		submitAjaxSuccess: 'i4:submitAjaxSuccess',
		updateFilter: 'i4:updateFilter'
    };

    this.init = function() {
	    this.popup = i4_Popup.get(this.$element);

	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$filterDecoratorCountry = $(this.selectors.filterDecoratorCountry);

	    this.$formParent.on(this.triggers.beforeSubmit, (function() {
		    i4_Popup.show_loader();
		    this.popup.hide();
	    }).bind(this));

	    this.$formParent.on(this.triggers.submitAjaxSuccess, (function() {
			i4_Popup.remove_all();
			this.$filterDecoratorCountry.trigger(this.triggers.updateFilter);
	    }).bind(this));
    };
}
